import { Typography, App } from 'antd';
import { ReactElement } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import useAuth from '../auth/hooks/useAuth';

const { Text } = Typography;

const Content = (): ReactElement => {
  const { login } = useAuth();
  const { message } = App.useApp();

  return (
    <>
      <Text type='secondary'>Googleアカウントでシステムにログインしてください</Text>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
        <GoogleLogin
          onSuccess={credentialResponse => {
            if (credentialResponse.credential) {
              login(credentialResponse.credential).catch((error: unknown) => {
                console.error('Login error:', error);
                void message.error('ログインできませんでした。管理者にお問い合わせください。');
              });
            }
          }}
          onError={() => {
            console.error('Google Sign-In error');
            void message.error('Google Sign-Inに失敗しました。もう一度お試しください。');
          }}
          theme='outline'
          size='large'
          text='signin_with'
          width='300'
        />
      </div>
    </>
  );
};

export default Content;
